import { useEcranAide, useDemandeEcran } from './aide/AideContexte';
import React, { useState, useEffect, useCallback } from 'react';
import { departementCourant, peutModifier } from '../services/droits';
import { stageAPI } from '../services/api';
import { EquipeStage } from './StageParametrageContacts';
import StageNotifications from './StageNotifications';

/**
 * SUIVI DE STAGE — l'onglet « PARAMÉTRAGE GÉNÉRAL » (écart E153, 2026-10-09)
 * =========================================================================
 * Ce qui vaut pour TOUT le module, et non pour une population :
 *   · Équipe — les assistantes et les responsables des stages (réglage du département, droit
 *     « modifier ») : copies des courriels stagiaires et tuteurs, refus d'un stage (E67),
 *     récapitulatif des notifications. Déplacé de Stagiaires → Paramétrage → Contacts.
 *   · Mes notifications — le réglage du COMPTE connecté (lot N.1), modifiable même en consultation.
 * Les « Paramétrage » de Stagiaires et de Tuteurs gardent ce qui leur est propre (processus,
 * modèles, courriels).
 */
const ECRANS = [
    { cle: 'equipe',        libelle: 'Équipe',            icone: 'fa-users' },
    { cle: 'notifications', libelle: 'Mes notifications', icone: 'fa-bell' }
];

// Lot L1a (E169) : la cloche du bandeau ouvre ce même écran sur « Mes notifications » (`ecranInitial`).
function StageParametrageGeneral({ config, user, anneeId, ecranInitial = 'equipe' }) {
    const [ecran, setEcran] = useState(ecranInitial);
    // Aide contextuelle (A1)
    useEcranAide('general/' + ecran);
    useDemandeEcran('general', (s) => { if (s === 'equipe' || s === 'notifications') setEcran(s); });
    const departementId = departementCourant(user, config);
    const modifiable = peutModifier(user, departementId, 'stage');
    const [contacts, setContacts] = useState(null);
    const [erreur, setErreur] = useState(null);

    // ⚠️ Aucun rappel de parent dans ces dépendances (leçon du lot 1.3 bis).
    const lire = useCallback(async () => {
        if (!departementId) return;
        try {
            const r = await stageAPI.getParametrage(departementId, anneeId);
            setContacts(r.data.contacts || { assistantes: [], responsables: [], utilisateurs_disponibles: [] });
            setErreur(null);
        } catch (e) {
            setErreur(e.response?.data?.detail || e.response?.data?.error || "Lecture de l'équipe impossible");
        }
    }, [departementId, anneeId]);
    useEffect(() => { if (ecran === 'equipe') lire(); }, [ecran, lire]);

    if (!departementId) {
        return <div className="stg-encart stg-encart-alerte"><i className="fa-solid fa-triangle-exclamation" /><span>Aucun département sélectionné.</span></div>;
    }

    return (
        <div>
            <div className="certif-entete">
                <div className="param-subtab-bar" role="tablist" aria-label="Paramétrage général">
                    {ECRANS.map((e) => (
                        <button key={e.cle} type="button" role="tab" aria-selected={ecran === e.cle}
                                className={'param-subtab' + (ecran === e.cle ? ' active' : '')} onClick={() => setEcran(e.cle)}>
                            <i className={'fa-solid ' + e.icone} /> {e.libelle}
                        </button>
                    ))}
                </div>
            </div>
            {ecran === 'equipe' && (<>
                {erreur && <div className="stg-encart stg-encart-erreur"><i className="fa-solid fa-circle-exclamation" /><span>{erreur}</span></div>}
                {!contacts && !erreur && <div className="stg-attente"><i className="fa-solid fa-circle-notch stg-tourne" /><div>Lecture de l'équipe…</div></div>}
                {contacts && <EquipeStage contacts={contacts} departementId={departementId} modifiable={modifiable} onContacts={setContacts} />}
            </>)}
            {ecran === 'notifications' && <StageNotifications departementId={departementId} />}
        </div>
    );
}

export default StageParametrageGeneral;
